import React from 'react';
import { Text } from '@ui';
import { formatDateTime } from './format';
import { platformStatusTag, t, whyText } from './labels';
function EventRow({ event, timeZone }) {
    var _a;
    const scheduled = formatDateTime(event.scheduledFor, timeZone);
    return (React.createElement("tr", null,
        React.createElement("td", null,
            React.createElement(Text, { variant: "xx-small", className: `push-history__kind push-history__kind--${event.kind}` }, t(`event_kind_names.${event.kind}`))),
        React.createElement("td", null,
            React.createElement(Text, { variant: "body" }, (_a = event.buildingName) !== null && _a !== void 0 ? _a : '—'),
            event.subject && React.createElement(Text, { variant: "xx-small", className: "push-history__muted" }, ` · ${event.subject}`)),
        React.createElement("td", null,
            React.createElement(Text, { variant: "xx-small", className: "push-history__muted" }, event.previousScheduledFor
                ? `${formatDateTime(event.previousScheduledFor, timeZone)} → ${scheduled}`
                : scheduled)),
        React.createElement("td", null,
            React.createElement("code", null, formatDateTime(event.occurredAt, timeZone)))));
}
function RailsHalf({ row, timeZone }) {
    if (row.events.length === 0) {
        return React.createElement("div", { className: "push-history__none" }, t('detail.no_events'));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("table", { className: "push-history__mini" },
            React.createElement("tbody", null, row.events.map((event) => (React.createElement(EventRow, { key: event.id, event: event, timeZone: timeZone }))))),
        row.events.map((event) => (React.createElement("details", { key: event.id, className: "push-history__payload" },
            React.createElement("summary", null, t('detail.payload', { id: event.id })),
            React.createElement("pre", null, JSON.stringify(event.payload, null, 2)))))));
}
function PlatformHalf({ row, timeZone, platformUnavailable }) {
    var _a, _b;
    if (!row.platform) {
        const outage = platformUnavailable && row.railsOutcome === 'published' && !!row.notificationId;
        return React.createElement("div", { className: "push-history__none" }, t(outage ? 'detail.platform_down' : 'detail.no_platform'));
    }
    const fields = [
        ['id', (_a = row.notificationId) !== null && _a !== void 0 ? _a : '—'],
        ['status', platformStatusTag(row.platform.status).label],
        ['failure_reason', (_b = row.platform.failureReason) !== null && _b !== void 0 ? _b : '—'],
        ['created_at', formatDateTime(row.platform.createdAt, timeZone)],
        ['dispatched_at', formatDateTime(row.platform.dispatchedAt, timeZone)],
        ['confirmed_at', formatDateTime(row.platform.confirmedAt, timeZone)],
        ['replay_count', String(row.platform.replayCount)]
    ];
    return (React.createElement("table", { className: "push-history__mini" },
        React.createElement("tbody", null, fields.map(([field, value]) => (React.createElement("tr", { key: field },
            React.createElement("td", { className: "push-history__field" },
                React.createElement("code", null, field)),
            React.createElement("td", null,
                React.createElement(Text, { variant: "body" }, value))))))));
}
/** The expanded half of a push row: why it looks the way it does, and both sides' records. */
export function PushHistoryDetail({ row, timeZone, platformUnavailable, columnCount }) {
    return (React.createElement("tr", { className: "push-history__detail-row" },
        React.createElement("td", { colSpan: columnCount },
            React.createElement("div", { className: "push-history__detail" },
                React.createElement(Text, { variant: "body", as: "p", className: "push-history__why" }, whyText(row, platformUnavailable)),
                React.createElement("div", null,
                    React.createElement(Text, { variant: "xx-small", className: "push-history__mini-heading push-history__mini-heading--rails" }, t('detail.rails_events')),
                    React.createElement(RailsHalf, { row: row, timeZone: timeZone })),
                React.createElement("div", null,
                    React.createElement(Text, { variant: "xx-small", className: "push-history__mini-heading push-history__mini-heading--platform" }, t('detail.platform_record')),
                    React.createElement(PlatformHalf, { row: row, timeZone: timeZone, platformUnavailable: platformUnavailable }))))));
}
